import { Marketing } from "components/Onboarding/Marketing/Marketing";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/onboarding/marketing")({
    component: Marketing,
});
